// rokid 外部链接
/**
 * 外部链接配置
 */
export const EXTERNAL_LINKS = {
  // 无工作空间时的帮助链接
  NO_WORKSPACE_HELP: 'https://jsj.top/f/wf9sm4',
} as const;

export type ExternalLinkKey = keyof typeof EXTERNAL_LINKS;

/**
 * 获取外部链接
 * @param key 链接key
 * @returns 链接URL
 */
export const getExternalLink = (key: ExternalLinkKey): string => {
  return EXTERNAL_LINKS[key];
};